export default {
  form: {
    shipping_company_name: {
      label: 'Empresa',
      placeholder: 'Ingresar nombre de empresa',
    },
    shipping_phone_number: {
      label: 'Número de teléfono',
      placeholder: 'Ingresar número de teléfono',
    },
    shipping_salutation: {
      label: 'Tratamiento',
      options: {
        mr: 'Sr.',
        mrs: 'Sra.',
      },
    },
    shipping_first_name: {
      label: 'Nombre',
      placeholder: 'Ingresar nombre',
    },
    shipping_last_name: {
      label: 'Apellido',
      placeholder: 'Ingresar apellido',
    },
  },
  buttons: {
    back: 'Atrás',
    next: 'Siguiente',
  },
};
